// 공통 테이블 컴포넌트
export const TradeTable = ({ columns, data }) => {
    return (
      <div className="FxMuiTable">
        <table>
          <colgroup>
            {columns.map((_, idx) => (
              <col key={idx} style={{width: `${100/columns.length}%`}} />
            ))}
          </colgroup>
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
          {data.length > 0 ? (
            data.map((row, idx) => (
              <tr key={idx}>
                {columns.map((col, colIdx) => (
                  <td key={colIdx}>{row[col]}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: 'center', padding: '20px 0' }}>
                데이터가 없습니다
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
    );
  };